module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS12.33181f8a.jpg";